var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIt5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,21a1,1,0,0,1,2,0v1h2V21a3,3,0,0,0-6,0v1h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,21a1,1,0,0,1,2,0v1h2V21a3,3,0,0,0-6,0v1h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,25H15v1a4,4,0,0,0,8,0V25H21v1a2,2,0,0,1-4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,41a5.006,5.006,0,0,0-5-5H33.886A7,7,0,0,0,29,34H24V32.9a12.065,12.065,0,0,0,1.619-.9H35V18A16,16,0,0,0,3,18V32h9.381A12.065,12.065,0,0,0,14,32.9V34H9a7.008,7.008,0,0,0-7,7V61a1,1,0,0,0,1,1H59a3,3,0,0,0,3-3V56H60Zm-2,0V56H30V41a3,3,0,0,1,3-3H55A3,3,0,0,1,58,41ZM9,16H29v6A10,10,0,0,1,9,22Zm22,4h1a1,1,0,0,1,0,2H31ZM27.919,30a11.942,11.942,0,0,0,2.9-6H32a2.966,2.966,0,0,0,1-.184V30ZM19,4A14.015,14.015,0,0,1,33,18v.184A2.966,2.966,0,0,0,32,18H31V15a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v3H6a2.966,2.966,0,0,0-1,.184V18A14.015,14.015,0,0,1,19,4ZM7,22H6a1,1,0,0,1,0-2H7ZM5,23.816A2.966,2.966,0,0,0,6,24H7.181a11.942,11.942,0,0,0,2.9,6H5ZM19,34a11.932,11.932,0,0,0,3-.4V35a3,3,0,0,1-6,0V33.6A11.932,11.932,0,0,0,19,34ZM4,41a5.006,5.006,0,0,1,5-5h5.1a5,5,0,0,0,9.8,0H29a5,5,0,0,1,2,.422A5,5,0,0,0,28,41V56H26v3a2.966,2.966,0,0,0,.184,1H12V47H10V60H4ZM60,59a1,1,0,0,1-1,1H29a1,1,0,0,1-1-1V58H60Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.707 49.293 38.414 47 40.707 44.707 39.293 43.293 35.586 47 39.293 50.707 40.707 49.293"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.707 50.707 52.414 47 48.707 43.293 47.293 44.707 49.586 47 47.293 49.293 48.707 50.707"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.838,
    y: 46,
    width: 6.325,
    height: 2,
    transform: "translate(-14.506 73.87) rotate(-71.556)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIt5);
export default __webpack_public_path__ + "static/media/IT5.33cf7dc9.svg";
export { ForwardRef as ReactComponent };